import { render, staticRenderFns } from "./History.vue?vue&type=template&id=2177b379&scoped=true&"
import script from "./History.vue?vue&type=script&lang=js&"
export * from "./History.vue?vue&type=script&lang=js&"
import style0 from "./History.vue?vue&type=style&index=0&lang=css&"
import style1 from "./History.vue?vue&type=style&index=1&id=2177b379&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2177b379",
  null
  
)

export default component.exports